import {Component} from "react";
import * as React from "react";
import {LabeledField} from './LabeledField'
import {imageUrl} from '../../helpers/ApplicationHelper'
import I18n from 'lib/i18n/i18n';

class BoxedSelectList extends Component {

    otherBox = {
        name:"other",
        text:I18n.getString("submitForm::otherBoxText")
    }

    notSureBox = {
        name:"notSure",
        text:I18n.getString("submitForm::notSureText")
    }

    constructor(props) {
        super(props)
        this.state = {
            otherSelected:false,
            otherWrapperStyle:{},
            otherValue:""
        }

        // if we have a value and it's not one of the options - than other is selected.
        if ( props.value && !props.options.find(o => o.text === props.value) && props.fillOtherOption ) {
            this.state.otherSelected = true
            this.state.otherValue = props.value
        }

        this.boxClicked = this.boxClicked.bind(this)
        this.updateValue = this.updateValue.bind(this)
    }

    updateValue(value) {
        // handle the special case of 'other'
        if ( value === this.otherBox.text && this.props.fillOtherOption ) {
            if ( !this.state.otherSelected ) {
                // the 'other' box has just been selected. notify state and clear the current brand value.
                this.setState({otherSelected: true})
            } else {
                // other has already been previously selected. nothing to do in this case
            }
            value = ""
        } else if ( this.props.options.map(o => o.text).indexOf(value) > -1 ) {
            // Explaining the 'if' above: we use the 'value' argument both for understanding the selected box,
            // and for setting the value of the selected brand. Once the 'other' box is selected and the input
            // field is available - any text within it will become the current selected brand.
            // when a different box is selected - the selected brand name will be one of the options...
            this.setState({otherSelected:false,otherValue:""})
        }

        this.props.onValueChanged(this.props.name,value)
    }

    boxClicked(event) {
        event.stopPropagation() // we don't won't the parent to close due to the click.

        // get the text from the data-automation
        let name = event.currentTarget.attributes["data-automation"].value
        if ( name === this.otherBox.name ) {
            this.updateValue(this.otherBox.text)
        } else if( name === this.notSureBox.name){
            this.updateValue(this.notSureBox.text)
        }
        else {
            let item = this.props.options.find(x => x.name === name)
            if (item) {
                this.updateValue(item.text)
            }
        }
    }

    renderBox(item,isOther) {
        let style = {}
        let showName = this.props.showName

        // is the current item the selected item?
        let selected = this.props.value === item.text || isOther && this.state.otherSelected

        // do we need to render a background image?
        if ( !selected && item.img && item.img.length ) {
            style = { backgroundImage: "url("+imageUrl(item.img)+")" }
        }
        else if ( selected && item.imgSelected && item.imgSelected.length ) {
            style = { backgroundImage: "url("+imageUrl(item.imgSelected)+")" }
        } else {
            showName = true
        }
        let text = isOther && this.props.fillOtherOption ? item.text + '...' : item.text

        return <div className={"boxed-select-list-item " + (selected ? "selected" : "")}
                    data-automation={item.name}
                    key={item.name}
                    style={style}
                    onClick={this.boxClicked} >

            {showName || isOther ? <span className={item.name}>{text}</span> : "" }
        </div>
    }

    renderOther() {
        return this.renderBox(this.otherBox,true)
    }

    renderOtherSelected() {
        return <LabeledField
                    placeholder={this.props.otherPlaceholder}
                    fieldLabel={"Other " + this.props.label.toLowerCase()}
                    updateValue={this.updateValue}
                    value={this.state.otherValue}
            />
    }

    renderChildren() {
        return <div>
            { this.props.hasNotSure ? this.renderBox(this.notSureBox) : null }
            { this.props.options.map(o => this.renderBox(o)) }
            { this.props.hasOther ? this.renderOther() : null }
        </div>
    }

    render() {
        let mainClass = "boxed-select-list " +
            (this.props.isOpen ? "open " : "closed ") +
            (this.state.otherSelected ? "other ": "") +
            (this.props.addClass ? this.props.addClass : "")

        return <div className={mainClass} >
            <div className="boxed-select-list-options-wrapper">
                { this.renderChildren() }
            </div>
            <div className={"boxed-select-list-other-wrapper"} style={this.state.otherWrapperStyle}>
                { this.state.otherSelected ? this.renderOtherSelected() : null }
            </div>
        </div>
    }
}

export {BoxedSelectList}